import { defineSlotRecipe } from '@chakra-ui/react';
import { toastAnatomy } from '@chakra-ui/react/anatomy';

export const toastSlotRecipe = defineSlotRecipe({
  slots: toastAnatomy.keys(),
  className: 'chakra-toast',
  base: {
    root: {
      '&[data-type=info]': {
        bg: 'blue.solid',
        color: 'blue.contrast',
        '--toast-trigger-bg': '{white/10}',
        '--toast-border-color': '{white/40}'
      }
    }
  }
});
